module.exports = __webpack_public_path__ + "static/media/39.9c5e735c.jpg";